import { axios } from '@/request-clients/axios';
import { useMutation } from '@tanstack/react-query';

export const useReportClientInformation = () => {
  return useMutation({
    // No language: this is sent on every page load, so it could not tell a choice the person made
    // from the Dutch it fell back to. Choices go to the language endpoint instead (IP-2221).
    mutationFn: async () => {
      const url = `clients/chat/user-information`;
      const response = await axios.post(url, {
        type: 3, // ClientDeviceType.Web,
      });

      return response.data;
    },
    retry: false,
  });
};
